import React from 'react';
import Profile from '../components/Profile/Profile';

const ProfilePage = () => <Profile />;

export default ProfilePage;
